var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[(_vm.type === 'video')?_c('video',{ref:"mediaRef",attrs:{"width":"100%","controls":""}}):_c('audio',{ref:"mediaRef",attrs:{"width":"100%","controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }